import { render } from "./match.vue?vue&type=template&id=625b45d5&scoped=true"
import script from "./match.vue?vue&type=script&lang=js"
export * from "./match.vue?vue&type=script&lang=js"

import "./match.vue?vue&type=style&index=0&id=625b45d5&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625b45d5"]])

export default __exports__